import React from 'react'
import TealiumAudienceStreamTable from '../../../components/Tealium/TealiumAudienceStream/TealiumAudienceStreamTable';
import { useContentfulContext } from '../../../contexts/ContentfulContext';

const TealiumAudienceStreamPage = () => {
  const { content } = useContentfulContext();

  return (
    <div className="w-full px-4 md:px-8 my-6">
      <main id="main" className="flex flex-col space-y-3 items-start flex-grow">
        <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl">{ content.TEALIUM_AUDIENCE_STREAM_CONTENT.title }</h1>
        <div className="flex flex-col pb-6 w-full">
            <p>{ content.TEALIUM_AUDIENCE_STREAM_CONTENT.description }</p>
            <TealiumAudienceStreamTable />
        </div>
      </main>
    </div>
  )
}

export default TealiumAudienceStreamPage;
